// This is the bottle neck for the application all sass and js files will be loaded through this file.
// config file is for webpack.
import config from '@/config';
import '../scss/main.scss';

// if you want to load new JS scripts u can import the files here
// import './components/file';
// or with variable:
// import variableName from './components/file';

//import "babel-polyfill";

import './important/object-fit.js';

// import './important/lazyload.js';
// import './optional/swiper.js';

// Vendor
import './vendor/jquery.youtubebackground.js';

import './components/detect-ie.js'
import './components/swiper.js';
import './components/headroom.js';
import './components/navigation.js';
import './components/main.js';
import './components/rrssb.js';
import './components/progress.js';
import './components/youtube.js';
import './components/faq.js';
import './components/search.js';
import './components/interactives.js';
import './components/fancybox.js';
import './components/vue/vendor/numberFormat.js';
import './components/popup.js';

// Vue JS & Axios
import Vue from 'vue'
import App from './components/app.vue'
import Search from './components/search.vue'

if (document.getElementById('app')) {
    new Vue({
        el: '#app',
        render: h => h(App)
    })
}

if (document.getElementById('search')) {
    new Vue({
        el: '#search',
        render: h => h(Search)
    })
}
